import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { InvoiceModel } from '@data-layer/models/entry-summaries';

@Component({
  selector: 'desktop-shipment-type-sidebar',
  template: `
    <desktop-shipment-details-type [isSideBar]="true" [invoices]="invoices" (dataSaved)="dataSaved.emit()"></desktop-shipment-details-type>
  `,
  styleUrls: ['./desktop-shipment-type-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopShipmentTypeSidebarComponent {
  @Input() public invoices: InvoiceModel[] = [];
  @Output() public dataSaved: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}
}
